<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import http from "@/plugins/axios";
import {th} from "vuetify/locale";
import router from "@/router";

export default {
  name: 'App',


  data: () => ({
    auth : [],
  }),
  metaInfo: {
    title: 'یزد تکس',
    titleTemplate: '%s | My Awesome Webapp'
  },
  methods: {
    checkValidApi() {
      if(!this.$isMobile()){
        // window.location.href = "http://www.yazdtexco.com/";
        // router.push("https://www.yazdtexco.com/");
      }

      // this.auth = localStorage.getItem("code");
      // if(this.code ==100){
      //   router.push("/home");
      // }else{
      //
      //   http.get("/getConnect")
      //       .then(response => {
      //         this.code = localStorage.setItem("code",response.data.code);
      //       }).catch(error => {
      //   });
      //   if(this.code ==100){
      //     router.push("/home");
      //   }else{
      //     router.push("/login");
      //   }
      //
      // }
    },
  },
  watch: {
    title: {
      immediate: true,
      handler() {
        document.title = 'شرکت بازرگانی یزدتکس';
      }
    }
  },
  mounted() {
    this.checkValidApi();
  },
}
</script>
<style>
 #app{
   font-family: iranyekan;
   direction: rtl;
   background-color: #e8e8e8;
   background-image: url('assets/newback1.png');
   background-repeat: repeat;
   background-size: cover;
 }
</style>